
import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/entities')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") {        
        return Api.put('api/entities/' + id , payload)       
    } else {
        return Api.post('api/entities' , payload)       
    }    
};

const getById =  (payload) => {        
    return Api.get('api/entities/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/entities/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById,
  
};